export const FilterMessage = (props: { filterType: string }) => (
  <div className="text-sm text-red-500">
    The selected standard and data scope have no data points for{" "}
    {props.filterType}. Change the filter to{" "}
    <span className="font-bold">All Assignments</span> to expand scope beyond{" "}
    {props.filterType}.
  </div>
);
